export default function EventContent(): string {
  return `DBL PLAY MABAR NATIONAL CHAMPIONSHIP S1-2022!
  
  Akhirnya tim juara dari masing-masing serie se-Indonesia akan segara bertanding di dalam format single round robin dari 8 grup yang terisi 6 tim tiap grup. Tim yang mengumpulkan poin terbanyak dari tiap grup akan lanjut ke babak NATIONAL CHAMPIONSHIP PLAYOFFS!
`;
}
